import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { right } from "@popperjs/core";

export default function CancellationReasons(props: any) {
  let data = props.data;
  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      style={{ borderLeft: "1px solid  #DAE0E4", margin: "0" }}
    >
      <Grid item xs={2} className="titleCancelReason">
        عنوان
      </Grid>
      <Grid item xs={9.5} className="bodyCancelReason">
        {data.reasons.map((item: string, index: number) => (
          <span
            style={{
              color: "#fff",
              background: "#1D4A87",
              padding: "4px 4px",
              borderRadius: "7px",
              margin: "5px 10px",
              width: "100%",
            }}
            key={index}
          >
            &nbsp;{item}&nbsp;
          </span>
        ))}
      </Grid>

      {data.description ? (
        <>
          <Grid item xs={2} className="titleCancelReason">
            توضیحات
          </Grid>
          <Grid item xs={9.5} className="bodyCancelReason">
            {data.description}
          </Grid>
        </>
      ) : null}

      <Grid item xs={2} className="titleCancelReason">
        تاریخ لغو درخواست
      </Grid>
      <Grid
        item
        xs={9.5}
        className="bodyCancelReason"
        style={{ direction: "ltr", textAlign: "right" }}
      >
        <span>{data.cancelDatePersian}</span>
      </Grid>
    </Grid>
  );
}
